import DepositModal from './deposit-modal';

export default DepositModal;
